/* Copyright (c) 2021 Magnusson Institute, All Rights Reserved */
import React from 'react';
import { Grid, LinearProgress, Paper, Typography } from "@mui/material";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import SwipeableViews from 'react-swipeable-views';
import * as __ from 'lib384/dist/384.esm'
import Products from 'components/Products';
import { config } from 'config';
import Checkout from 'components/Checkout';
import PaymentStatus from 'components/PaymentStatus';
import SnackabraContext from 'contexts/SnackabraContext';
import { ChannelStoreType } from "react384"
import Login from 'components/Login';
import WalletContext from "../contexts/WalletContext";

const stripePromise = loadStripe(config.stripe_pk);

const Home = () => {
  const wallet = React.useContext(WalletContext)
  const channelBudgetInterval = React.useRef<NodeJS.Timeout | null>(null)
  const SBContext = React.useContext(SnackabraContext)
  const [activeStep, setActiveStep] = React.useState(0);
  const [paymentSuccess, setPaymentSuccess] = React.useState<boolean>(false)
  const [product_id, setProductID] = React.useState<string>('')
  const [confirmedWalletId, setConfirmedWalletId] = React.useState<string>('')
  const [confirmingPayment, setConfirmingPayment] = React.useState<boolean>(false)
  const [channel, setChannel] = React.useState<ChannelStoreType | null>(null)
  const [storageAmount, setStorageAmount] = React.useState<number>(0)
  // const [walletId, setWalletId] = React.useState<string | undefined>(config.wallet_from_384_os)
  // const [walletKey, setWalletKey] = React.useState<JsonWebKey | undefined>(config.jwk_from_384_os)

  React.useEffect(() => {
    const queryString = window.location.search;

    // Create a URLSearchParams object from the query string
    const searchParams = new URLSearchParams(queryString);

    // Initialize an empty object to store the parsed query parameters
    const queryParams: { [key: string]: string } = {};

    // Iterate over the searchParams and populate the queryParams object
    for (const [key, value] of searchParams) {
      queryParams[key] = value;
    }
    if (window.location.hash !== confirmedWalletId && queryParams['payment_intent'] !== undefined) {
      const walletId = window.location.hash.replace('#', '')
      setConfirmedWalletId(walletId)
      // Get the query string from the current URL
      const queryString = window.location.search;

      // Create a URLSearchParams object from the query string
      const searchParams = new URLSearchParams(queryString);

      // Initialize an empty object to store the parsed query parameters
      const queryParams: { [key: string]: string } = {};

      // Iterate over the searchParams and populate the queryParams object
      for (const [key, value] of searchParams) {
        queryParams[key] = value;
      }
      console.log(queryParams)
      // __.wallet.set(walletId)
      // SBContext.
    }
  }, [window.location.hash])


  React.useEffect(() => {
    if (SBContext && wallet.id && wallet.identity) {
      connect()
    }
  }, [SBContext, wallet.id, wallet.identity])

  React.useEffect(() => {
    if (channel) {
      if (channelBudgetInterval.current) clearInterval(channelBudgetInterval.current)

      channelBudgetInterval.current = setInterval(() => {
        getBalance()
      }, 5000)
      if (storageAmount === 0) getBalance()
    }
  }, [channel])

  function convertSize(bytes: number) {
    const units = ['KB', 'MB', 'GB', 'TB'];
    let index = 0;

    while (bytes > 1024) {
      bytes /= 1024;
      if (bytes.toFixed(0).length <= 3) break
      index++;
    }

    return `${bytes.toFixed(2)} ${units[index]}`;
  }

  const getBalance = async () => {
    if (!channel) return
    console.log(channel)
    // console.log(channel.getStorageAmount())
    channel.getStorageAmount().then((amount: any) => {
      console.log('++++++++++++++++++++')
      console.log(amount)
      setStorageAmount(amount)
    })
  }

  const messageHandler = (message: any) => {
    console.log(message)
  }

  const connect = async () => {
    if (!SBContext) throw new Error('SBContext is null')
    if (!wallet.id) throw new Error('walletId is undefined')
    if (!wallet.identity) throw new Error('walletKey is undefined')
    console.log(wallet)
    if (!SBContext.channels[wallet.id]) {
      await SBContext.join(wallet.id, wallet.identity)
    }
    const _c = SBContext.channels[wallet.id] as ChannelStoreType
    console.log(SBContext.channels[wallet.id].key)
    _c.connect(messageHandler).then((c) => {
      console.log(c)
      setChannel(_c)
    })

  }


  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setProductID('')
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const onCheckout = (product_id: string) => {
    handleNext()
    setProductID(product_id)
  }
  const cleanURL = () => {
    // Get the current URL
    const currentURL = window.location.href;

    // Remove query parameters and hash
    const newURL = currentURL.split('?')[0].split('#')[0];

    // Set the new URL without query parameters and hash
    window.history.replaceState({}, document.title, newURL);
  }

  const onSuccess = () => {
    setConfirmingPayment(false)
    fetch(config.payment_api + '/success', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        wallet_id: confirmedWalletId
      })
    }).then((response) => {
      return response.json()
    }
    ).then((data) => {
      console.log(data)
      setPaymentSuccess(true)
      setTimeout(() => {
        cleanURL()
        setActiveStep(0)
        setPaymentSuccess(false)
        setProductID('')
        setConfirmedWalletId('')
        setConfirmingPayment(false)
      }, 5000)
    }
    ).catch((error) => {
      console.log(error)
      alert('Something went wrong. Please try again.')
    })
  }

  const onError = () => {
    setConfirmingPayment(false)
    alert('Something went wrong. Please try again.')
  }

  if (!wallet.id || !wallet.identity) return <Login />

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ padding: 0, height: '100%', width: '100%', background: 'none' }}
    >

      <Paper sx={{ p: 3, height: '100%', width: '100%' }}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={3}
        >
          <Grid item xs={12} sx={{ mb: 3 }}>
            <Typography variant="h4">
              384 Inc Store
            </Typography>
            {config.mode === 'development' && <Typography variant="subtitle1" color="yellow" component="div" noWrap>
              Development Mode {convertSize(storageAmount)}
            </Typography>
            }
            {config.mode === 'production' && <Typography variant="subtitle1" color="yellow" component="div" noWrap>
              Current Storage {convertSize(storageAmount)}
            </Typography>
            }
          </Grid>
          {!confirmingPayment && confirmedWalletId !== '' ?
            <Grid item xs={12} sx={{ mb: 3 }}>
              {paymentSuccess ? null :
                <>
                  <Typography variant="h6">Verifying Payment </Typography>
                  <Typography variant="body1" color='red'>Do not navigate away from this page</Typography>
                  <LinearProgress color="inherit" />
                </>
              }
              <Elements stripe={stripePromise}>
                <Typography variant="body1">
                  <PaymentStatus onSuccess={onSuccess} onError={onError} />
                </Typography>
              </Elements>
            </Grid>
            :
            <SwipeableViews style={{ padding: 0 }} index={activeStep}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={{ pl: 3 }}
                spacing={3}
              >
                <Products onCheckout={onCheckout} />
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={{ pl: 3 }}
                spacing={3}
              >
                {channel &&
                  <Checkout product_id={product_id} onBack={handleBack} channel={channel} />
                }
              </Grid>
            </SwipeableViews>
          }

        </Grid>
      </Paper>

    </Grid>
  )
}

export default Home;


